<template>
  <div class="purple-round-input input-wrapper">
    <input
      class="w-full h-12 outline-none"
      type="number"
      inputmode="numeric"
      v-model="data"
      :placeholder="$t('settingUserData.weight')"
      @input="onInput"
      @blur="emitInput"
    />
    <span class="unit-text">{{ currentUnit }}</span>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';

const RATIO = 0.453;

export default {
  name: 'Weight',
  props: {
    value: [Number, String],
  },
  data: vm => ({
    data: vm.value,
  }),
  methods: {
    onInput() {
      if (!this.isUsingMetric) return;

      this.emitInput();
    },
    emitInput() {
      const weight = parseFloat(this.data) * (!this.isUsingMetric ? RATIO : 1);
      this.$emit('input', Math.round(weight));
    },
    toImperial() {
      this.data = Math.round(parseFloat(this.data) / RATIO);
    },
    toggleUnit() {
      const old = parseFloat(this.data);
      const newValue = this.isUsingMetric ? old * RATIO : old / RATIO;
      this.data = `${Math.round(newValue)}`;
      this.$nextTick(() => {
        this.emitInput();
      });
    },
  },
  computed: {
    ...mapGetters('app', ['isUsingMetric']),
    currentUnit() {
      return this.isUsingMetric ? this.$t('settingUserData.kg') : this.$t('settingUserData.lbs');
    },
  },
  watch: {
    isUsingMetric() {
      this.toggleUnit();
    },
    value(nv, ov) {
      if (!ov && nv) {
        this.data = nv;
        if (!this.isUsingMetric) {
          this.toImperial();
        }
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.input-wrapper {
  @apply pl-6 pr-2;
}
.unit-text {
  @apply text-xxs text-center font-medium opacity-50;
  color: #2245ff;
  white-space: nowrap;
}
</style>
